module.exports = __webpack_public_path__ + "img/home_banner.07ceb0f7.png";